import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { AgreementProduct, AgreementProductFormValues } from "@modules/agreements/types/agreementProduct";
import { AgreementProductPlan, AgreementProductPlanFormValues } from "@modules/agreements/types/agreementProduct";


export async function getAgreementProductsService(agreementId?: number): Promise<AgreementProduct[]> {
  try {
    const { data } = await api.get<ApiResponse<AgreementProduct>>(`v1/product_admin/`, {
      params: {
        agreement: agreementId,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching agreement products:", error);
    throw error;
  }
}

export async function getAgreementProductByIdService(id: number): Promise<AgreementProduct | null> {
  try {
    const { data } = await api.get<AgreementProduct>(`v1/product_admin/${id}/`);
    return data;
  } catch (error) {
    console.error("Error fetching agreement product:", error);
    throw error;
  }
}

export async function createAgreementProductService(product: AgreementProductFormValues, agreementId: number): Promise<AgreementProduct> {
  try {
    const { data } = await api.post<AgreementProduct>(`v1/product_admin/`, {
      ...product,
      agreement: agreementId,
    });
    return data;
  } catch (error) {
    console.error("Error creating agreement product:", error);
    throw error;
  }
}

export async function updateAgreementProductService(id: number, product: Partial<AgreementProductFormValues>): Promise<AgreementProduct> {
  try {
    const { data } = await api.patch<AgreementProduct>(`v1/product_admin/${id}/`, product);
    return data;
  } catch (error) {
    console.error("Error updating agreement product:", error);
    throw error;
  }
}

export async function deleteAgreementProductService(id: number): Promise<void> {
  try {
    await api.delete(`v1/product_admin/${id}/`);
  } catch (error) {
    console.error("Error deleting agreement product:", error);
    throw error;
  }
}

export async function getAgreementProductPlansService(filters?: {
  agreement?: number;
  product?: number;
}): Promise<AgreementProductPlan[]> {
  try {
    const { data } = await api.get<ApiResponse<AgreementProductPlan>>(`v1/subscription_plan_admin/`, {
      params: filters,
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching agreement product plans:", error);
    throw error;
  }
}

export async function getAgreementProductPlanByIdService(id: number): Promise<AgreementProductPlan | null> {
  try {
    const { data } = await api.get<AgreementProductPlan>(`v1/subscription_plan_admin/${id}/`);
    return data;
  } catch (error) {
    console.error("Error fetching agreement product plan:", error);
    throw error;
  }
}

export async function createAgreementProductPlanService(plan: AgreementProductPlanFormValues, productId: number): Promise<AgreementProductPlan> {
  try {
    const { data } = await api.post<AgreementProductPlan>(`v1/subscription_plan_admin/`, {
      ...plan,
      product: productId,
    });
    return data;
  } catch (error) {
    console.error("Error creating agreement product plan:", error);
    throw error;
  }
}

export async function updateAgreementProductPlanService(id: number, plan: Partial<AgreementProductPlanFormValues>): Promise<AgreementProductPlan> {
  try {
    const { data } = await api.patch<AgreementProductPlan>(`v1/subscription_plan_admin/${id}/`, plan);
    return data;
  } catch (error) {
    console.error("Error updating agreement product plan:", error);
    throw error;
  }
}

export async function deleteAgreementProductPlanService(id: number): Promise<void> {
  try {
    await api.delete(`v1/subscription_plan_admin/${id}/`);
  } catch (error) {
    console.error("Error deleting agreement product plan:", error);
    throw error;
  }
}
